import { requestGet } from '@/common/request'

export default {
  async AnnounceList (query) {
    return await requestGet('/announce/list', query)
  },
  async AnnounceShow (query) {
    return await requestGet('/announce/show', query)
  },
  // 查询项目列表
  async HelpListCategory (query) {
    return await requestGet('/help/listCategory', query)
  }

}
